module.exports = __webpack_public_path__ + "static/media/leah.a78fb924.jpg";